export default {
  "start": {
    "twoMinutes": "2 Minutes",
    "safeAndSecure": "Safe & Secure",
    "multipleOffers": "Multiple Offers",
    "variants": {
      "default": {
        "headline": "Get your Personal Loan in minutes",
        "subheadline": "Check your rate with no impact to your credit score",
        "ctaText": "Check Your Rate"
      },
      "debt_consolidation": {
        "headline": "Consolidate Your Debt Today",
        "subheadline": "Simplify your payments with one fixed monthly payment",
        "ctaText": "Consolidate My Debt"
      },
      "home_improvement": {
        "headline": "Fund Your Dream Home Project",
        "subheadline": "Get the funds you need for renovations and improvements",
        "ctaText": "Get My Home Loan"
      },
      "emergency_fund": {
        "headline": "Get Emergency Funds Fast",
        "subheadline": "Access funds quickly when life throws you a curveball",
        "ctaText": "Get Emergency Funds"
      },
      "personalized": {
        "headline": "You're Eligible for a Personal Loan",
        "subheadline": "Complete your application to access your personalized offer",
        "ctaText": "Access My Offer",
        "headlineWithName": "Hi {{firstName}}, you're Eligible for a Personal Loan",
        "headlineWithNameAndAmount": "Hi {{firstName}}, you're Eligible for up to {{amount}}"
      }
    }
  },
  "email": {
    "title": "What's your email?",
    "description": "We'll use this to send you important updates about your application",
    "submit": "Continue",
    "requiredError": "Please enter your email address"
  },
  "birthDate": {
    "title": "What's your date of birth?",
    "description": "Enter your birthdate to confirm eligibility (must be 18+)",
    "submit": "Continue",
    "requiredError": "Please enter your date of birth"
  },
  "contactInfo": {
    "title": "Enter Your Phone Number",
    "phoneLabel": "Mobile Phone",
    "submit": "Continue",
    "processing": "Processing...",
    "smsDisclaimer": "By continuing, you agree to receive SMS messages, phone calls, and emails—potentially using automated technology or prerecorded/artificial voice—from Symple Lending and its lending partners (\"<partnersLink>Partners</partnersLink>\") regarding application updates and account-related communications. Message/data rates may apply; frequency varies. Reply HELP for assistance or STOP to cancel.",
    "creditDisclaimer": "By continuing, you also provide Symple Lending and its <partnersLink>Partners</partnersLink> express written consent to obtain your credit report for application purposes. You also agree to <spinwheelLink>Spinwheel's End User Agreement</spinwheelLink> and authorize Spinwheel Solutions, Inc. to retrieve your credit profile from any consumer reporting agency."
  },
  "phoneVerification": {
    "title": "Check Your Text Messages",
    "description": "Enter the 6-digit code before it expires",
    "mobilePhoneLabel": "Mobile Phone:",
    "birthDateLabel": "Birth Date:",
    "promoConsent": "(Optional) I agree to receive product updates and promotional offers from Symple Lending and its Partners via SMS messages, phone calls, emails, or other methods, which may use automated technology or prerecorded/artificial voice. Consent is not a condition of purchase. Message/data rates may apply; frequency varies. Reply HELP for assistance or STOP to cancel.",
    "verifying": "Verifying...",
    "submit": "Get My Results",
    "resend": "Resend verification code",
    "reenter": "Update mobile phone/birth date"
  },
  "loanAmount": {
    "title": "Loan Amount",
    "descriptionDefault": "How much would you like to borrow?",
    "descriptionOffer": "You're eligible for {{amount}}. You can adjust if needed.",
    "originalOffer": "Original offer:",
    "submit": "Continue",
    "decreaseAria": "Decrease amount",
    "increaseAria": "Increase amount"
  },
  "loanPurpose": {
    "title": "Loan Purpose",
    "description": "What's the primary reason for this loan?",
    "options": {
      "debt_consolidation": {
        "label": "Debt Consolidation",
        "description": "Combine multiple debts into one payment"
      },
      "credit_card_refi": {
        "label": "Credit Card Refinancing",
        "description": "Refinance high-interest credit card debt"
      },
      "emergency": {
        "label": "Emergency Expenses",
        "description": "Cover unexpected costs or emergencies"
      },
      "home_improvement": {
        "label": "Home Improvement",
        "description": "Renovate or repair your home"
      },
      "large_purchases": {
        "label": "Large Purchases",
        "description": "Finance major expenses or purchases"
      },
      "other": {
        "label": "Other",
        "description": "Other personal expenses"
      }
    }
  },
  "propertyStatus": {
    "title": "Property Status",
    "description": "What's your current living situation?",
    "options": {
      "own_outright": {
        "label": "Own Outright",
        "description": "You own your home with no mortgage"
      },
      "own_with_mortgage": {
        "label": "Own with Mortgage",
        "description": "You own your home and have a mortgage"
      },
      "rent": {
        "label": "Rent",
        "description": "You rent your residence"
      }
    }
  },
  "employmentStatus": {
    "title": "Employment Status",
    "description": "What best describes your current employment?",
    "options": {
      "employed_full_time": {
        "label": "Full-Time Employed",
        "description": "40+ hours per week"
      },
      "employed_part_time": {
        "label": "Part-Time Employed",
        "description": "Less than 40 hours per week"
      },
      "self_employed": {
        "label": "Self-Employed",
        "description": "Business owner or freelancer"
      },
      "military": {
        "label": "Military",
        "description": "Active duty or reserve military service"
      },
      "employed": {
        "label": "Other Employment",
        "description": "Other employment arrangement"
      },
      "retired": {
        "label": "Retired",
        "description": "Receiving retirement income"
      },
      "not_employed": {
        "label": "Not Currently Employed",
        "description": "Not working at this time"
      },
      "other": {
        "label": "Other",
        "description": "None of the above"
      }
    }
  },
  "employmentFrequency": {
    "title": "Pay Frequency",
    "description": "How often do you receive your paycheck?",
    "options": {
      "weekly": {
        "label": "Weekly",
        "description": "Paid once per week"
      },
      "biweekly": {
        "label": "Biweekly",
        "description": "Paid every two weeks"
      },
      "twice_monthly": {
        "label": "Twice Monthly",
        "description": "Paid twice per month (e.g., 1st and 15th)"
      },
      "monthly": {
        "label": "Monthly",
        "description": "Paid once per month"
      }
    }
  },
  "annualIncome": {
    "title": "Annual Income",
    "description": "What is your total annual income?",
    "tooltip": "Total annual income is your “gross income before taxes.”",
    "decreaseAria": "Decrease income",
    "increaseAria": "Increase income",
    "submit": "Continue",
    "disclaimer": "Provide your total available income including wages, retirement, investments, and rental properties. Alimony, child support or separate maintenance is optional and does not need to be included if you do not wish it to be considered as a basis for repaying the loan. Increase any non taxable income or benefits by 25%."
  },
  "education": {
    "title": "Education Level",
    "description": "What's your highest level of education?",
    "options": {
      "did_not_graduate": {
        "label": "Did Not Graduate",
        "description": "Did not complete high school"
      },
      "high_school": {
        "label": "High School",
        "description": "High school diploma or GED"
      },
      "still_enrolled": {
        "label": "Currently Enrolled",
        "description": "Currently pursuing a degree"
      },
      "certificate": {
        "label": "Certificate/Certification",
        "description": "Professional certification or trade school"
      },
      "associate": {
        "label": "Associate's Degree",
        "description": "2-year college degree"
      },
      "bachelors": {
        "label": "Bachelor's Degree",
        "description": "4-year college degree"
      },
      "masters": {
        "label": "Master's Degree",
        "description": "Graduate level degree"
      },
      "doctorate": {
        "label": "Doctorate",
        "description": "Ph.D. or other doctoral degree"
      },
      "other_grad_degree": {
        "label": "Other Graduate Degree",
        "description": "Other advanced degree"
      },
      "other": {
        "label": "Other",
        "description": "Other educational background"
      }
    }
  },
  "ssnVerification": {
    "title": "Verify Your Identity",
    "description": "Enter the last 4 digits of your Social Security Number",
    "tooltip": "We use your social security number to validate your information and check your credit. This will NOT affect your credit score. Your information is transmitted securely.",
    "tooltipSrLabel": "How we use your SSN",
    "placeholder": "Last 4 digits",
    "disclaimerIntro": "By clicking \"Submit Application\" above:",
    "disclaimerConsent": "I consent to Symple Lending submitting my application to its <partnersLink>Partners</partnersLink> to evaluate my eligibility for personal loan offers and related financial products and services. By continuing, you also provide Symple Lending and its Partners express written consent to obtain your credit report for application purposes.",
    "disclaimerAck": "I acknowledge that each <partnerLink>Partner</partnerLink> has its own privacy practices and consent terms. To view the full list of <partnersLink2>Partners</partnersLink2> and their consent language, please visit <consentsLink>Lending Partners’ Consents and Disclosures</consentsLink>.",
    "submitting": "Submitting...",
    "submit": "Submit Application"
  },
  "applicationReview": {
    "title": "Let's finish your loan application",
    "description": "We've received your information from our partner. Please confirm or update your details below.",
    "detailsHeading": "Your Application Details",
    "rowLabels": {
      "loanAmount": "Loan Amount",
      "loanPurpose": "Loan Purpose",
      "employmentStatus": "Employment Status",
      "propertyStatus": "Property Status"
    },
    "notSpecified": "Not specified",
    "continue": "Continue",
    "editDetails": "Edit Details"
  },
  "kbaPersonalInfo": {
    "title": "Verify Your Identity",
    "description": "Please confirm your personal details so we can verify your identity",
    "selectStatePlaceholder": "-- Select your state --",
    "firstNameLabel": "First Name",
    "lastNameLabel": "Last Name",
    "streetLabel": "Street Address",
    "aptSuiteLabel": "Apt/Suite",
    "cityLabel": "City",
    "stateLabel": "State",
    "zipLabel": "ZIP Code",
    "zipError": "Please enter a valid 5-digit ZIP code",
    "saving": "Saving...",
    "submit": "Continue"
  },
  "kbaSsn": {
    "title": "Social Security Number",
    "description": "Enter your full Social Security Number to verify your identity",
    "tooltip": "We use your SSN to verify your identity and check your eligibility. This will NOT affect your credit score. Your information is transmitted securely.",
    "tooltipSrLabel": "How we use your SSN",
    "placeholder": "Enter your 9-digit SSN",
    "showAria": "Show SSN",
    "hideAria": "Hide SSN",
    "firstNameLabel": "First Name:",
    "lastNameLabel": "Last Name:",
    "streetLabel": "Street Address:",
    "cityLabel": "City:",
    "stateLabel": "State:",
    "zipLabel": "ZIP Code:",
    "birthDateLabel": "Birth Date:",
    "verifying": "Verifying...",
    "submit": "Continue",
    "updatePersonalInfo": "Update personal details",
    "updateBirthDate": "Update date of birth"
  },
  "kbaQuestions": {
    "title": "Security Questions",
    "description": "Please answer the following questions to verify your identity",
    "questionOf": "Question {{current}} of {{total}}",
    "submitting": "Submitting...",
    "submit": "Submit Answers"
  },
  "manualVerification": {
    "title": "Manual Verification",
    "description": "Please provide additional information to verify your identity",
    "selectStatePlaceholder": "-- Select your state --",
    "offerCodeLabel": "Offer Code",
    "firstNameLabel": "First Name",
    "lastNameLabel": "Last Name",
    "streetLabel": "Street Address",
    "aptSuiteLabel": "Apt/Suite",
    "cityLabel": "City",
    "stateLabel": "State",
    "zipLabel": "ZIP Code",
    "zipError": "Please enter a valid 5-digit ZIP code",
    "verifying": "Verifying...",
    "submit": "Submit",
    "tryPhoneAgain": "Try Phone Verification Again"
  },
  "reenterContact": {
    "title": "Update Phone Number",
    "description": "Enter your mobile phone number",
    "placeholder": "(555) 555-5555",
    "next": "Next"
  },
  "formatting": {
    "notSpecified": "Not specified",
    "loanPurpose": {
      "debt_consolidation": "Debt Consolidation",
      "credit_card_refi": "Credit Card Refinancing",
      "emergency": "Emergency Expenses",
      "home_improvement": "Home Improvement",
      "large_purchases": "Large Purchases",
      "other": "Other"
    },
    "employmentStatus": {
      "employed": "Employed",
      "employed_full_time": "Full-Time Employed",
      "employed_part_time": "Part-Time Employed",
      "military": "Military",
      "not_employed": "Not Employed",
      "self_employed": "Self-Employed",
      "retired": "Retired",
      "other": "Other"
    },
    "propertyStatus": {
      "own_outright": "Own Outright",
      "own_with_mortgage": "Own with Mortgage",
      "rent": "Rent"
    },
    "educationLevel": {
      "high_school": "High School or GED",
      "associate": "Associate's Degree",
      "bachelors": "Bachelor's Degree",
      "masters": "Master's Degree",
      "doctorate": "Doctorate",
      "other_grad_degree": "Other Graduate Degree",
      "certificate": "Certificate/Certification",
      "did_not_graduate": "Did Not Graduate",
      "still_enrolled": "Currently Enrolled",
      "other": "Other"
    }
  }
} as const;
